export default __webpack_public_path__ + "static/media/PhoneIcon.8cdc9e13.svg";